import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { X, Zap, Loader2 } from "lucide-react";

export default function SimulateModal({ open, onClose, onCreated }) {
  const [form, setForm] = useState({
    customer_name: "Maria Silva",
    customer_phone: "+5511999998888",
    amount: 97,
  });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const fire = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/simulate/pix-generated", {
        customer_name: form.customer_name,
        customer_phone: form.customer_phone,
        amount: Number(form.amount),
      });
      toast.success("PIX de teste gerado! Motor iniciou a sequência.");
      onCreated?.(data);
      onClose?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Falha ao simular");
    }
    setLoading(false);
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="simulate-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="cp-card relative w-full max-w-md">
        <div className="flex items-center justify-between border-b border-white/[0.06] p-5">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-md bg-amber-500/15 border border-amber-500/40 flex items-center justify-center">
              <Zap className="h-5 w-5 text-amber-400" />
            </div>
            <div>
              <div className="font-heading text-lg font-bold tracking-tight">Simular PIX</div>
              <div className="text-xs text-slate-500">Cria uma transação de teste e dispara a sequência</div>
            </div>
          </div>
          <button onClick={onClose} data-testid="close-simulate-modal" className="text-slate-500 hover:text-white">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="p-5 space-y-3">
          <div>
            <label className="block text-xs text-slate-400 mb-1.5">Nome do cliente</label>
            <input
              value={form.customer_name}
              onChange={update("customer_name")}
              data-testid="sim-name-input"
              className="w-full bg-cp-elevated border border-white/10 focus:border-cp-primary outline-none text-sm px-3 py-2.5 rounded-md"
            />
          </div>
          <div>
            <label className="block text-xs text-slate-400 mb-1.5">Telefone (com DDI)</label>
            <input
              value={form.customer_phone}
              onChange={update("customer_phone")}
              data-testid="sim-phone-input"
              className="w-full bg-cp-elevated border border-white/10 focus:border-cp-primary outline-none text-sm px-3 py-2.5 rounded-md font-mono"
            />
          </div>
          <div>
            <label className="block text-xs text-slate-400 mb-1.5">Valor (R$)</label>
            <input
              type="number"
              step="0.01"
              value={form.amount}
              onChange={update("amount")}
              data-testid="sim-amount-input"
              className="w-full bg-cp-elevated border border-white/10 focus:border-cp-primary outline-none text-sm px-3 py-2.5 rounded-md tabular-nums"
            />
          </div>
        </div>
        <div className="flex justify-end gap-2 border-t border-white/[0.06] p-5">
          <button onClick={onClose} className="px-4 py-2 text-sm text-slate-400 hover:text-white">
            Cancelar
          </button>
          <button
            onClick={fire}
            disabled={loading}
            data-testid="fire-sim-btn"
            className="bg-cp-primary hover:bg-cp-primary-hover disabled:opacity-40 text-cp-bg font-bold px-5 py-2 rounded-md inline-flex items-center gap-2 text-sm"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Zap className="h-4 w-4" />}
            Disparar PIX de teste
          </button>
        </div>
      </div>
    </div>
  );
}
